






import { DynamicDocumentItem, DynamicDocumentItemData, Nullable } from '@/types';
import Vue, { PropType } from 'vue';

export default Vue.extend({
  props: {
    item: Object as PropType<DynamicDocumentItem>,
    data: Object as PropType<DynamicDocumentItemData>,
  },

  computed: {
    meta(): Record<string, any> {
      return this.item.meta ?? {};
    },
  },
});
